module.exports = __webpack_public_path__ + "media/site_templates/www.cheapplumber.net.au/images/our_services_1-4002f5c71570e664ccaac4f40cd768a6.jpg";